export function NexusStatusBadge({ status }: { status: string }) {
  const tone =
    status === 'COMPLETED'
      ? 'bg-emerald-100 text-emerald-700'
      : status === 'FAILED' || status === 'SUBMISSION_FAILED' || status === 'CANCELLED'
        ? 'bg-red-100 text-red-700'
        : status === 'IN_PROGRESS'
          ? 'bg-blue-100 text-blue-700'
          : 'bg-amber-100 text-amber-700';
  return (
    <span className={`inline-flex rounded-full px-2 py-0.5 text-xs font-medium ${tone}`}>
      {status.replaceAll('_', ' ').toLowerCase()}
    </span>
  );
}
